﻿import * as styleTypes from '../utils/style/styleTypes';
import * as eventTypes from '../utils/eventTypes';

import { createOlStyleFunction } from '../utils/style/canvas/OlStyler';
import { transform, fromLonLat } from 'ol/proj';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { containsCoordinate, containsExtent } from 'ol/extent';
import WebGLLayer from '../layer/WebGLLayer';
export default class GeolocationHandler {
    constructor(layerHandler) {

        this.layerHandler = layerHandler;
        this.watchId = null;
        this.locationLayer = null;
        this.trackPosition = false;
        this.currentLocation = null;
        this.inside = false;
        this.watchInitialised = false;
    }

    init() {
        this._computeLocationLayer().then((layer) => {
            this.locationLayer = layer;
            this._addEventHandlers(this.map);
        });
    }

    watchPosition() {
        if (this.watchId != null) {
            this.clearWatch();
        }

        this.trackPosition = true;
        if (navigator.geolocation) {
            this.watchId = navigator.geolocation.watchPosition(this._handleWatchPosition(), this._handleWatchPositionError());
        } else {
            this._handleUnsupportedGeolocation();
        }
    }

    clearWatch() {
        this.trackPosition = false;
        this.watchInitialised = false;
        this._clearMapLocation();
        if (navigator.geolocation && this.watchId != null) {
            navigator.geolocation.clearWatch(this.watchId);
        } else {
            this._handleUnsupportedGeolocation();
        }
        this.watchId = null;
    }

    _handleWatchPosition() {
        let handler = (position) => {
            this.currentLocation = position;
            if (!this.watchInitialised) {
                this._centerMapLocation(position);
                this.watchInitialised = true;
            } else {
                this._addLocation(position);
            }

            this._checkCurrentLocation();
        }

        return handler;
    }

    _handleWatchPositionError() {
        var errorHandler = (error) => {
            this.clearWatch();
            var msg = "";
            var code = 0;
            if (error.code == 1 && error.message.indexOf("secure origins are allowed") > -1) {
                code = 2;
                msg = "Position unavailable";
            }
            else {
                switch (error.code) {
                    case 1:

                        msg = "User denied Geolocation ";
                        code = 1;
                        break;
                    case 2:
                    case 3:

                        code = 2;
                        msg = "Position unavailable";
                        break;
                    default:
                        msg = "Geolocation unsupported";
                }
            }
            $event.notify(eventTypes.GEOLOCATION_ERROR, { message: msg, code: code }, this, this.classId);
        }
        return errorHandler;
    }

    _addLocation(position) {
        this.locationLayer.getSource().clear(true);
        let feature = new Feature(new Point(transform([position.coords.longitude, position.coords.latitude], 'EPSG:4326', this.layerHandler.map.getView().getProjection().getCode())));
        feature.set('xstate', 0);
        this.locationLayer.getSource().addFeatures([
            feature
        ]);
    }

    _centerMapLocation(position) {
        var _position = transform([position.coords.longitude, position.coords.latitude], 'EPSG:4326', this.layerHandler.map.getView().getProjection().getCode());
        if (!containsExtent(this.layerHandler.map.getView().calculateExtent(), new Point(_position).getExtent())) {

            $event.notify(eventTypes.GEOLOCATION_ERROR, { message: "User location out of map bounds", code: 4 }, this, this.classId);
            return;
        }

        this.currentLocation = position;

        this._addLocation(position);

        this.layerHandler.map.getView().animate({
            center: _position,
            duration: 2000
        });
    }

    _addEventHandlers(map) {
        this.layerHandler.map.on(['postcompose'], this._handlePostComposeEvent());
    }

    _computeLocationLayer() {
        return new Promise((resolve, reject) => {
            this.layerHandler.styleHandler.loadStyle('sys_' + styleTypes.SYSTEM_STYLE_GEOLOCATION, true).then(() => {
                let style = this.layerHandler.styleHandler.getCombinedStyle('sys_' + styleTypes.SYSTEM_STYLE_GEOLOCATION, null, null);
                var source = new VectorSource();

                if (style.styleType == styleTypes.STYLE_TYPE_CANVAS) {
                    let styleFunction = (feature) => {
                        let styleGetter = createOlStyleFunction(style.style, this.layerHandler.map);
                        return styleGetter(feature);
                    }

                    var layer = new VectorLayer({
                        source: source,
                        style: styleFunction,
                        zIndex: this.layerHandler.temporaryLayerIdx,
                        visible: true
                    });
                    this.layerHandler.map.addLayer(layer);
                    resolve(layer);
                } else {
                    let layer = new WebGLLayer({
                        source: source,
                        zIndex: this.layerHandler.temporaryLayerIdx,
                        visible: true
                    });
                    layer.setCustomStyle(style.style.featureStyle);
                    this.layerHandler.map.addLayer(layer);
                    resolve(layer);
                }
            });
        });
    }

    _handlePostComposeEvent() {
        let handler = (evt) => {
            if (evt.type == 'postcompose' && this.trackPosition) {
                this._checkCurrentLocation();
            }
        }

        return handler;
    }

    _checkCurrentLocation() {
        if (this.currentLocation != null) {
            if (containsCoordinate(this.layerHandler.map.getView().calculateExtent(this.layerHandler.map.getSize()),
                transform([this.currentLocation.coords.longitude, this.currentLocation.coords.latitude],
                    'EPSG:4326', this.layerHandler.map.getView().getProjection().getCode()))) {
                if (!this.inside) {
                    $event.notify(eventTypes.CURRENT_LOCATION_VISIBLITY_CHANGED, { position: 'inside' }, this, this.classId);
                    this.inside = true;
                }
            } else {
                if (this.inside) {
                    $event.notify(eventTypes.CURRENT_LOCATION_VISIBLITY_CHANGED, { position: 'outside' }, this, this.classId);
                    this.inside = false;
                }
            }

            this.lastLocation = this.currentLocation;
        }
    }

    _clearMapLocation() {
        this.locationLayer.getSource().clear(true);
    }

    _handleUnsupportedGeolocation(error) {
        $event.notify(eventTypes.GEOLOCATION_ERROR, { message: "Geolocation unsupported", code: 0 }, this, this.classId);
    }
}